module.exports = __webpack_public_path__ + "static/image-free-sample-ad4372d7838a92384788eaffdd83b7cd.png";